<template>
    <div class="libro">
        <div class="content">
            <b-row>
                <b-col cols="12" lg="10" offset-lg="1">
                    <b-row>
                        <b-col cols="12" md="6">
                            <img src="../assets/img/img_book.jpg" alt="Libro">
                        </b-col>
                        <b-col cols="12" md="6" lg="5" offset-lg="1">
                            <h3><span>Cambias</span> o te cambian</h3>
                            <p>por Hanniel Maldonado</p>
                            <p class="text">Haz RESET y aprende los 11 fundamentos para dirigir a un equipo de ventas y hacerlo excepcionalmente bien.</p>
                            <a href="https://amzn.to/2Tyd0iv" target="_blank" class="btn">adquiere tu libro en amazon</a>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </div>
        <b-modal ref="modalLibro" size="xl" centered hide-footer id="modalLibro">
            <b-row>
                <b-col cols="12" order="2" lg="6" order-lg="1" class="modalText">
                    <h3><span>Cambias</span> o te cambian</h3>
                    <p>por Hanniel Maldonado</p>
                    <p class="text">Haz RESET y aprende los 11 fundamentos para dirigir a un equipo de ventas y hacerlo excepcionalmente bien.</p>
                    <a href="https://amzn.to/2Tyd0iv" target="_blank" class="btn">adquiere tu libro en amazon</a>
                </b-col>
                <b-col cols="12" order="1" lg="6" order-lg="2">
                    <img src="../assets/img/img_book.jpg" alt="Libro">
                </b-col>
            </b-row>
        </b-modal>
    </div>
</template>

<script>
    export default {
        mounted() {
            setTimeout(()=>{ 
                this.$refs['modalLibro'].show(); 
            }, 2000);
        }
    }
</script>

<style scoped>
    .libro{
        padding: 100px 0 0 0;
    }
    .row{
        align-items: center;
    }
    .text{
        margin: 30px 0;
    }
    img{
        width: 100%;
    }
    .btn{
        width: 250px;
        max-width: 100%;
    }
    .modalText{
        padding: 30px 8%;
    }
    @media screen and (max-width: 767px){
        .libro{
            padding: 80px 0 0 0;
        }
        img{
            margin-bottom: 40px;
        }
    }
</style>

<style>
   
    #modalLibro .modal-header{
        position: absolute;
        background-color: transparent;
    }
    #modalLibro .modal-content{
        box-shadow: none!important;
    }
    #modalLibro .modal-body{
        padding: 0;
    }
    #modalLibro *{
        text-align: left;
    }
    #modalLibro h3{
        color: #171717!important;
    }
    #modalLibro .btn{
        text-align: center!important;
    }
</style>


// WEBPACK FOOTER //
// src/components/Libro.vue